module.exports = __webpack_public_path__ + "img/sortdropdown.14692b29.svg";